export const getInsurancePlanNameFromTier = (tier: string) => {
  switch (tier) {
    case 'low':
      return 'Essential';
    case 'medium':
      return 'Enhanced';
    default:
      return tier;
  }
};
